import React from "react";
import AntdDivider from 'antd/lib/divider';
import { withError} from '@fishx/tracker';

const Divider = (props) => <AntdDivider {...props} />

Divider.displayName = 'Divider';

export default withError(Divider);



// WEBPACK FOOTER //
// ./src/components/divider/index.tsx